<template>
  <section class="ask-fallback-view">
    <div v-if="showBanner" class="fallback-banner">
      <p class="fallback-banner__title">Structured response unavailable</p>
      <p class="fallback-banner__text">
        Displaying the raw model output because structured parsing failed.
      </p>
    </div>

    <details v-if="hasLimitations" class="answer-details" open>
      <summary>Limitations</summary>
      <ul>
        <li v-for="(limitation, index) in limitations" :key="`fallback-limitation-${index}`">
          {{ limitation }}
        </li>
      </ul>
    </details>

    <section class="answer-narrative answer-narrative--standalone">
      <div class="section-heading">
        <p class="section-heading__eyebrow">Full narrative</p>
      </div>
      <div
        v-if="sanitizedAnswerHtml"
        class="answer-html"
        v-html="sanitizedAnswerHtml"
      ></div>
      <p v-for="(paragraph, index) in responseParagraphs" v-else :key="`fallback-paragraph-${index}`" class="answer-text">
        {{ paragraph }}
      </p>
    </section>
  </section>
</template>

<script>
export default {
  name: 'AskFallbackView',
  props: {
    showBanner: {
      type: Boolean,
      default: true,
    },
    limitations: {
      type: Array,
      default: () => [],
    },
    sanitizedAnswerHtml: {
      type: String,
      default: '',
    },
    responseParagraphs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasLimitations() {
      return Array.isArray(this.limitations) && this.limitations.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.ask-fallback-view {
  display: flex;
  flex-direction: column;
  gap: $space-4;
}

.fallback-banner {
  border: 1px solid rgba(180, 83, 9, 0.25);
  border-radius: $radius-md;
  background: rgba(255, 247, 237, 0.9);
  padding: $space-3;
}

.fallback-banner__title,
.fallback-banner__text,
.answer-text {
  margin: 0;
}

.fallback-banner__title {
  font-weight: 700;
  color: #9a3412;
}

.fallback-banner__text {
  margin-top: $space-1;
  color: #7c2d12;
}

.section-heading {
  margin-bottom: $space-3;
}

.section-heading__eyebrow {
  margin: 0 0 $space-1;
  font-size: $font-size-xs;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: $color-primary-dark;
}

.answer-details summary {
  font-weight: 600;
  color: $color-primary-dark;
  cursor: pointer;
}

.answer-details ul {
  margin: $space-2 0 0;
  padding-left: 1.1rem;
}

.answer-narrative--standalone {
  margin-bottom: 0;
}

.answer-text {
  white-space: pre-line;
}

.answer-text + .answer-text {
  margin-top: $space-3;
}

.answer-html :deep(p) {
  margin: 0;
}

.answer-html :deep(p + p),
.answer-html :deep(p + ul),
.answer-html :deep(p + ol),
.answer-html :deep(ul + p),
.answer-html :deep(ol + p),
.answer-html :deep(ul + ul),
.answer-html :deep(ol + ol),
.answer-html :deep(ul + ol),
.answer-html :deep(ol + ul) {
  margin-top: $space-3;
}

.answer-html :deep(ul),
.answer-html :deep(ol) {
  margin: 0;
  padding-left: 1.35rem;
}

.answer-html :deep(ul) {
  list-style: disc;
}

.answer-html :deep(ol) {
  list-style: decimal;
}

.answer-html :deep(li + li) {
  margin-top: $space-2;
}
</style>
